import { useState, useEffect } from 'react';
import { Layout, Drawer, Grid, theme } from 'antd';
import { useLocation } from 'react-router-dom';
import HeaderBar from './HeaderBar';
import SidebarNav from './SidebarNav';
import { useAuth } from '../auth/AuthContext';

const { Sider, Content, Footer } = Layout;
const { useBreakpoint } = Grid;
const { useToken } = theme;

const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAdmin } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const { token } = useToken();
  const screens = useBreakpoint();
  const location = useLocation();

  // Phone widths: < 768px (no `md` breakpoint). Use Drawer instead of Sider.
  const isMobile = !screens.md;

  // Close the mobile drawer automatically when navigating to a new route.
  // Without this, the drawer stays open after the user taps a menu item.
  useEffect(() => {
    setMobileDrawerOpen(false);
  }, [location.pathname]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Desktop / tablet sidebar */}
      {!isMobile && (
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          breakpoint="lg"
          collapsedWidth={80}
        >
          <div
            style={{
              height: 32,
              margin: 16,
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: collapsed ? 12 : 16,
            }}
          >
            {collapsed ? 'MP' : 'MIMO Portal'}
          </div>
          <SidebarNav isAdmin={isAdmin} />
        </Sider>
      )}

      {/* Mobile drawer */}
      {isMobile && (
        <Drawer
          placement="left"
          open={mobileDrawerOpen}
          onClose={() => setMobileDrawerOpen(false)}
          closable={false}
          width={260}
          styles={{
            body: { padding: 0, background: '#001529' },
            header: { display: 'none' },
          }}
        >
          <div
            style={{
              height: 32,
              margin: 16,
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: 16,
            }}
          >
            MIMO Portal
          </div>
          <SidebarNav isAdmin={isAdmin} />
        </Drawer>
      )}

      <Layout>
        <HeaderBar showHamburger={isMobile} onHamburgerClick={() => setMobileDrawerOpen(true)} />
        <Content
          style={{
            padding: isMobile ? '12px' : '24px',
            background: token.colorBgLayout,
          }}
        >
          {children}
        </Content>
        <Footer
          style={{
            textAlign: 'center',
            padding: isMobile ? '12px 16px' : '12px 50px',
            fontSize: isMobile ? 12 : 14,
          }}
        >
          MIMO Connect &copy; {new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
